import { render } from "./PopUp.vue?vue&type=template&id=4eca8be4&scoped=true&ts=true"
import script from "./PopUp.vue?vue&type=script&lang=ts"
export * from "./PopUp.vue?vue&type=script&lang=ts"

import "./PopUp.vue?vue&type=style&index=0&id=4eca8be4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\Renault\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eca8be4"]])

export default __exports__